import script from "./GroomProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./GroomProfile.vue?vue&type=script&setup=true&lang=js"

import "./GroomProfile.vue?vue&type=style&index=0&id=295a3290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295a3290"]])

export default __exports__